// src/components/ExportReportExcel.jsx
import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button, CircularProgress } from '@mui/material';
import { API_BASE_URL } from 'src/apiConfig';

export default function ExportReportExcel() {
  const [loading, setLoading] = useState(false);

  const exportReportExcel = async () => {
    setLoading(true);
    try {
      // 1) uzmi JSON sa back-enda
      const { data } = await axios.get(
        `${API_BASE_URL}/api/students.php?exportReport=1`
      );

      const rows = data.map((item) => {
        const obj = {
          Школа: item.school,
          Место: item.place,
          Језик: item.language
        };
        let total = 0;
        for (let i = 1; i <= 12; i++) {
          const cnt = item.counts[i] || 0;
          obj[`${i}`] = cnt;
          total += cnt;
        }
        obj['Укупно'] = total;
        return obj;
      });

      // 3) kreiraj workbook i sheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(rows, {
        header: [
          'Школа',
          'Место',
          'Језик',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
          'Укупно'
        ]
      });
      XLSX.utils.book_append_sheet(wb, ws, 'Извештај');

      // 4) preuzmi fajl
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'kengur_report.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Export error:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={exportReportExcel}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={16} /> : null}
      sx={{
        marginLeft: '10px',
        marginBottom: '20px',
        backgroundColor: '#180954f0',
        color: '#ffffff',
        borderRadius: '8px',
        padding: '10px 20px',
        fontWeight: 'bold'
      }}
    >
      Export Excel
    </Button>
  );
}
